import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=dcff7058&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=dcff7058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff7058",
  null
  
)

export default component.exports